// Modules
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

// Components
import Spinner from '../spinner/SpinnerView';

// Styling
import './button.scss';

const Button = (props) => {
    const { className, onClick, text, type, title } = props;

    // Render a Loading button when className has 'currently-saving'
    if (className.indexOf('currently-saving') !== -1) {
        return (
            <button className={cx('btn', { [className]: !!className })}>
                <Spinner />
            </button>
        );
    }

    return (
        <button
            type={type ? type : 'button'}
            className={cx('btn', { [className]: !!className })}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            title={title}>
            {text}
        </button>
    );
};

Button.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    text: PropTypes.string,
};

export default Button;
